/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-12-17 14:40:16
 * @FilePath: \baishu_react_ui\src\Login\LoginCodeSetName\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, {Component} from 'react';
import PubSub from 'pubsub-js'
import BsyBtn from "../BsyBtn";
import tipAlert from "../BsyAlertTip/Staticize";
import './index.css'
import BsySLoading from "../../components/BsySLoading";

class LoginCodeSetName extends Component {
    constructor(props) {
        super(props);
        this.state={
            showClear:false,
            showSkip:false,
            isLoading: false,
            name:''
        }
    }

    changeValue = (event) =>{
        const val = event.target.value
        if(val!==''){
            this.setState({showClear:true})
        }else{
            this.setState({showClear:false})
        }
        this.setState({name:val})
    }

    clearInputValue = (event) =>{
        event.target.previousSibling.value="";
        event.target.parentNode.classList.remove('phone')
        this.setState({showClear:false})
    }

    setName = () =>{
        const {name} = this.state
        const {changeContCodePage} = this.props
        if(name.length<=0){
            tipAlert({
                type: "error",
                msg : React.language('set.name.empty.tip')
            })
            return ;
        }
        if(this.state.isLoading){
            return;
        }
        this.setState({isLoading: true}, ()=> {
            React.axios('/user/signin',{
                "mode":"register",
                "data":{
                    "username":name, //姓名
                }
            }).then(res =>{
                if(res.data.code===200){
                    tipAlert({
                        type: "success",
                        msg : res.data.msg
                    })
                    changeContCodePage("LoginCodeSetPasswordShow")
                    PubSub.publish('codeReg',{value:true});
                }else if(res.data.code===400){
                    tipAlert({
                        type: "error",
                        msg : res.data.msg
                    })
                }
                setTimeout(()=>{
                    this.setState({isLoading: false})
                }, 1000)
            }).catch(res=>{
                // tipAlert({
                //     type: "error",
                //     msg : res.response.data.msg
                // })
                setTimeout(()=>{
                    this.setState({isLoading: false})
                }, 1000)
            })
        })
    }

    render() {
        const {showClear, isLoading} = this.state
        return (
          <div className='LoginCodeSetName'>
              {isLoading && <BsySLoading style={{background: "#fff", zIndex: 9999999999}}/>}
              <div className="codeTitle">
                  <span>{React.language('set.name.new')}</span>
              </div>
              <div className="codeTip">
                  <span>{React.language('set.name.new.t')}</span>
              </div>
              <div className="setNameInput">
                  <input onChange={this.changeValue} type="text" placeholder={React.language('set.name.new.p')}/>
                  {showClear && <i onClick={this.clearInputValue} className="icon-dingding-guide-close"/>}
              </div>
              <BsyBtn style={{pointerEvents: isLoading ? "none" : ""}} onClick={this.setName} text={React.language('ok')} />
          </div>
        );
    }
}

export default LoginCodeSetName;